module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-medium-f935475c.ttf";